export enum ContactAdvantagesEnum {
    ADVANTAGE_30 = "advantage-30",
    ADVANTAGE_30_20 = "advantage-30-20",
    ADVANTAGE_50 = "advantage-50",
}
export const contractAdvantagesEnum = Object.values(ContactAdvantagesEnum);
export type ContractAdvantages = (typeof contractAdvantagesEnum)[number];
